<template>
  <div class="custom-select">
    <div class="edit-table">
      <div class="title_2">预算信息</div>
      <vxe-toolbar v-if="!disabled" style="margin-left: 125px">
        <template v-slot:buttons>
          <vxe-button @click="openModal('one')">新增</vxe-button>
          <vxe-button @click="clearFn()">清空</vxe-button>
        </template>
      </vxe-toolbar>
      <vxe-table :data="feeBudgetList" style="margin-left: 125px">
        <vxe-table-column
          min-width="150"
          field="feeBudgetCode"
          title="费用预算编码"
        ></vxe-table-column>
        <vxe-table-column
          min-width="150"
          field="feeBudgetTypeName"
          title="费用预算类型"
        ></vxe-table-column>
        <vxe-table-column
          min-width="150"
          field="budgetSubjectsName"
          title="预算科目名称"
        ></vxe-table-column>
        <vxe-table-column
          min-width="150"
          field="canUseAmount"
          title="可用余额"
        ></vxe-table-column>
        <vxe-table-column
          min-width="150"
          field="budgetYear"
          title="财年"
        ></vxe-table-column>
        <vxe-table-column
          min-width="150"
          field="orgName"
          title="组织"
        ></vxe-table-column>
        <vxe-table-column
          min-width="150"
          field="orgCode"
          title="组织编码"
        ></vxe-table-column>
        <!-- <vxe-table-column
          min-width="150"
          field="customerName"
          title="经销商名称"
        ></vxe-table-column>
        <vxe-table-column
          min-width="150"
          field="customerCode"
          title="经销商编码"
        ></vxe-table-column>
        <vxe-table-column
          min-width="150"
          field="ext10"
          title="职位名称"
        ></vxe-table-column>
        <vxe-table-column
          min-width="150"
          field="ext9"
          title="职位编码"
        ></vxe-table-column> -->
        <vxe-table-column
          min-width="150"
          field="productLevelName"
          title="产品系列"
        ></vxe-table-column>
        <vxe-table-column
          min-width="150"
          field="ext8"
          title="公司主体"
        ></vxe-table-column>
        <vxe-table-column
          min-width="150"
          field="customerCode"
          title="经销商编码"
        ></vxe-table-column>
        <vxe-table-column
          min-width="150"
          field="customerName"
          title="经销商名称"
        ></vxe-table-column>
        <vxe-column title="操作" width="80" v-if="!disabled">
          <template #default="{ row, rowIndex }">
            <template>
              <span
                @click="deletRow(row, rowIndex)"
                style="color: red; cursor: pointer"
                >删除</span
              >
            </template>
          </template>
        </vxe-column>
      </vxe-table>
      <div v-if="transferType">
        <div class="title_2" v-if="transferType">
          {{ transferType === "discountPool" ? "折扣池" : "终端红包池" }}
        </div>
        <vxe-toolbar v-if="!disabled" style="margin-left: 125px">
          <template v-slot:buttons>
            <vxe-button @click="addRow">新增</vxe-button>
            <vxe-button @click="clearFn()">清空</vxe-button>
          </template>
        </vxe-toolbar>
        <vxe-table
          :key="transferType"
          :data="detailBudgetList"
          style="margin-left: 125px"
        >
          <vxe-table-column
            min-width="200"
            field="createDateAll"
            title="预算信息"
          >
            <template #default="{ row, rowIndex }">
              <el-select
                v-model="row.feeBudgetCode"
                @change="changeFeeBudgetCode($event, rowIndex)"
                @focus="getFeeBudgetList(rowIndex)"
                placeholder="请选择预算信息"
                :disabled="disabled"
              >
                <el-option
                  v-for="citem in detailBudgetList[rowIndex].ysOptions"
                  :key="citem.value"
                  :label="citem.label"
                  :value="citem.value"
                >
                </el-option>
              </el-select>
            </template>
          </vxe-table-column>
          <vxe-table-column
            disabled
            min-width="150"
            field="budgetYear"
            title="财年"
          ></vxe-table-column>
          <vxe-table-column
            v-if="transferType === 'discountPool'"
            min-width="200"
            field="businessObjectName"
            title="经销商名称"
          >
            <template #default="{ row, rowIndex }">
              <div
                @click="getCustList(rowIndex)"
                style="position: relative"
              >
                <el-input
                  v-model="row.businessObjectName"
                  placeholder="请选择经销商"
                  :disabled="disabled || row.cantOpen"
                  readonly
                >
                </el-input>
              </div>
            </template>
            <!-- <template #default="{ row, rowIndex }">
              <el-select
                v-model="row.businessObjectName"
                @change="changCust($event, rowIndex)"
                @focus="() => getCustList(rowIndex)"
                :remote-method="(v) => getCustList(rowIndex, v)"
                remote
                clearable
                filterable
                placeholder="请选择经销商"
                :disabled="disabled || row.cantOpen"
              >
                <el-option
                  v-for="item in detailBudgetList[rowIndex].custOptions"
                  :key="item.businessObjectCode"
                  :label="item.businessObjectName"
                  :value="item.businessObjectCode"
                >
                </el-option>
              </el-select>
            </template> -->
          </vxe-table-column>
          <vxe-table-column
            v-if="transferType === 'redPacketPool'"
            min-width="200"
            field="businessObjectName"
            title="终端名称"
          >
            <template #default="{ row, rowIndex }">
              <div
                @click="openTerminalModal(rowIndex)"
                style="position: relative"
              >
                <el-input
                  v-model="row.businessObjectName"
                  placeholder="请选择终端名称"
                  :disabled="disabled"
                  readonly
                >
                </el-input>
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column
            v-if="transferType === 'discountPool'"
            min-width="200"
            field="companyName"
            title="公司主体"
          >
            <template #default="{ row, rowIndex }">
              <el-select
                v-model="row.companyName"
                @change="companyChange($event, rowIndex)"
                placeholder="请选择公司主体"
                :disabled="disabled"
              >
                <el-option
                  v-for="item in companyList"
                  :key="item.companyCode"
                  :label="item.companyName"
                  :value="item.companyCode"
                >
                </el-option>
              </el-select>
            </template>
          </vxe-table-column>
          <vxe-table-column
            v-if="transferType === 'redPacketPool'"
            min-width="200"
            field="companyName"
            title="红包发放主体"
          >
            <template #default="{ row, rowIndex }">
              <el-select
                v-model="row.companyName"
                @change="redPacketCompanyChange($event, rowIndex)"
                placeholder="请选择红包发放主体"
                :disabled="disabled"
              >
                <el-option
                  v-for="item in WJBT_transfer_red_pack_ZT"
                  :key="item.dictCode"
                  :label="item.dictValue"
                  :value="item.dictCode"
                >
                </el-option>
              </el-select>
            </template>
          </vxe-table-column>
          <vxe-table-column
            v-if="transferType === 'discountPool'"
            min-width="200"
            field="productName"
            title="产品名称"
          >
            <template #default="{ row, rowIndex }">
              <div
                @click="getProList(rowIndex)"
                style="position: relative"
              >
                <el-input
                  v-model="row.productName"
                  placeholder="请选择产品"
                  :disabled="disabled"
                  readonly
                >
                </el-input>
              </div>
            </template>
            <!-- <template #default="{ row, rowIndex }">
              <el-select
                v-model="row.productName"
                @change="choosePro($event, rowIndex)"
                @focus="getProList(rowIndex)"
                placeholder="请选择产品"
                :disabled="disabled"
              >
                <el-option
                  v-for="item in detailBudgetList[rowIndex].proOptions"
                  :key="item.materialCode"
                  :label="item.materialName"
                  :value="item.materialCode"
                >
                </el-option>
              </el-select>
            </template> -->
          </vxe-table-column>
          <vxe-table-column
            v-if="transferType === 'redPacketPool'"
            min-width="200"
            field="orgName"
            title="红包发放组织"
          >
            <template #default="{ row, rowIndex }">
              <el-select
                v-model="row.orgName"
                @change="orgChange($event, rowIndex)"
                placeholder="请选择红包发放组织"
                :disabled="disabled"
              >
                <el-option
                  v-for="item in WJBT_transfer_red_pack_ZZ"
                  :key="item.dictCode"
                  :label="item.dictValue"
                  :value="item.dictCode"
                >
                </el-option>
              </el-select>
            </template>
          </vxe-table-column>
          <vxe-table-column
            disabled
            min-width="150"
            field="transferAmount"
            title="划转金额"
          >
            <template #default="{ row }">
              <el-input
                v-model="row.transferAmount"
                placeholder="请输入划转金额"
                :disabled="disabled"
              ></el-input>
            </template>
          </vxe-table-column>
          <vxe-column title="操作" width="80" v-if="!disabled">
            <template #default="{ row, rowIndex }">
              <template>
                <span
                  @click="deletRowOne(row, rowIndex)"
                  style="color: red; cursor: pointer"
                  >删除</span
                >
              </template>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
    </div>
    <!-- 弹框 -->
    <SelectConfig ref="selectConfig" @onGetSelect="onGetSelect" />
  </div>
</template>

<script>
import SelectConfig from '@/found/components/select_org_cus_ter/select_config.vue';
import request from '@/found/utils/request';

export default {
  name: 'product_list',
  props: {
    value: Object,
    disabled: Boolean,
    transferType: String,
  },
  data() {
    return {
      detailBudgetList: [],
      feeBudgetList: [],
      companyList: [],
      openType: '',
      ysOptions: [],
      chooseIndex: -1,
      WJBT_transfer_red_pack_ZT: [],
      WJBT_transfer_red_pack_ZZ: [],
      feeBudgetType: [],
      // state: '',
    };
  },
  components: {
    SelectConfig,
  },
  created() {
    this.getCompanyList();
    this.getDictory();
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          this.detailBudgetList = val.detailBudgetList || [];
          this.feeBudgetList = (val.feeBudgetList || []).map((v) => {
            const feeBudgetTypeObj = this.feeBudgetType.find(
              (item) => item.dictCode === v.feeBudgetType,
            );
            return {
              ...v,
              feeBudgetTypeName: feeBudgetTypeObj?.dictValue || v.feeBudgetType,
            };
          });
        } else {
          this.detailBudgetList = [];
          this.feeBudgetList = [];
        }
      },
    },
    transferType: {
      handler(val) {
        console.log('???', val);
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    // 新增弹窗
    openModal(type) {
      this.openType = type;
      console.log(type);
      let params = {};
      if (type === 'one') {
        if (!this.transferType) {
          this.$message({
            type: 'warning',
            message: '请选择划转类型',
          });
          return;
        }
        params = {
          functionCode: 'budget-list',
          data: this.feeBudgetList || [],
          idKey: 'feeBudgetCode',
          paramData: {
            transferType: this.transferType,
          },
        };
      } else if (type === 'two') {
        params = {
          functionCode: 'terminal-list',
          data: [],
          idKey: 'terminalCode',
          paramData: {},
        };
      } else if (type === 'product') {
        // 获取所选行的完整数据
        const selectedItem = this.detailBudgetList[this.chooseIndex].ysOptions.find(
          (item) => item.value === this.detailBudgetList[this.chooseIndex].feeBudgetCode,
        );
        params = {
          functionCode: 'product-list',
          data: [],
          idKey: 'materialCode',
          paramData: {
            code: selectedItem.productLevelCode,
          },
        };
      } else if (type === 'customer') {
        params = {
          functionCode: 'customer-list',
          data: [],
          idKey: 'customerCode',
          paramData: {
            orgCode: this.detailBudgetList[this.chooseIndex].orgCode,
            enableStatus: '009',
          },
        };
      }
      params.noReset = true;
      this.$refs.selectConfig.openSelectModal(params);
    },
    openTerminalModal(rowIndex) {
      if (this.disabled) {
        return;
      }
      this.chooseIndex = rowIndex;
      this.openModal('two');
    },
    // 货补池新增
    addRow() {
      if (!this.feeBudgetList.length) {
        this.$message({
          type: 'warning',
          message: '至少选择一条预算',
        });
        return;
      }
      console.log(this.ysOptions);
      if (this.transferType === 'discountPool') {
        this.detailBudgetList.push({
          feeBudgetCode: '',
          ysOptions: this.ysOptions,
          custOptions: [],
          proOptions: [],
          budgetYear: '',
          businessObjectCode: '',
          businessObjectName: '',
          companyCode: '',
          companyName: '',
          productName: '',
          productCode: '',
          transferAmount: '',
          transferType: this.transferType,
          cantOpen: false,
        });
      } else {
        this.detailBudgetList.push({
          feeBudgetCode: '',
          ysOptions: this.ysOptions,
          custOptions: [],
          proOptions: [],
          budgetYear: '',
          businessObjectCode: '',
          businessObjectName: '',
          companyCode: '',
          companyName: '',
          orgCode: '',
          orgName: '',
          transferAmount: '',
          transferType: this.transferType,
        });
      }
    },
    // 选择预算
    changeFeeBudgetCode(row, index) {
      console.log(row, index);
      if (this.transferType === 'discountPool') {
        this.$set(this.detailBudgetList[index], 'productName', null);
        this.$set(this.detailBudgetList[index], 'productCode', null);
      } else {
        this.$set(this.detailBudgetList[index], 'orgCode', '');
        this.$set(this.detailBudgetList[index], 'orgName', '');
      }
      this.$set(this.detailBudgetList[index], 'feeBudgetCode', row);
      this.$set(this.detailBudgetList[index], 'custOptions', []);
      this.$set(this.detailBudgetList[index], 'businessObjectCode', '');
      this.$set(this.detailBudgetList[index], 'businessObjectName', '');
      this.$set(this.detailBudgetList[index], 'companyName', null);
      this.$set(this.detailBudgetList[index], 'companyCode', null);
      this.$set(this.detailBudgetList[index], 'transferAmount', null);

      // 获取所选行的完整数据
      const selectedItem = this.detailBudgetList[index].ysOptions.find(
        (item) => item.value === row,
      );
      console.log(selectedItem);
      if (selectedItem) {
        this.$set(
          this.detailBudgetList[index],
          'budgetYear',
          selectedItem.budgetYear,
        );
        this.$set(
          this.detailBudgetList[index],
          'businessObjectName',
          selectedItem.customerName,
        );
        this.$set(
          this.detailBudgetList[index],
          'businessObjectCode',
          selectedItem.customerCode,
        );
        if (selectedItem.customerCode) {
          this.$set(
            this.detailBudgetList[index],
            'cantOpen',
            true,
          );
        } else {
          this.$set(
            this.detailBudgetList[index],
            'cantOpen',
            false,
          );
        }
      }
    },
    getFeeBudgetList(index) {
      console.log(this.feeBudgetList);
      const ysOptions = [];
      this.feeBudgetList.forEach((itt) => {
        ysOptions.push({
          label: itt.feeBudgetCode,
          value: itt.feeBudgetCode,
          budgetYear: itt.budgetYear,
          productLevelCode: itt.productLevelCode,
          productLevelName: itt.productLevelName,
          orgCode: itt.orgCode,
          orgName: itt.orgName,
          customerCode: itt.customerCode,
          customerName: itt.customerName,
        });
      });
      this.$set(this.detailBudgetList[index], 'ysOptions', ysOptions || []);
    },
    getCustList(index) {
      if (this.disabled || this.detailBudgetList[index].cantOpen) {
        return;
      }
      if (!this.detailBudgetList[index].feeBudgetCode) {
        this.$message({
          type: 'warning',
          message: '请选择预算',
        });
        return;
      }
      this.chooseIndex = index;
      this.openModal('customer');
      // request.post('/tpm/tpmawardtransform/findCustomerInfo', { channelFeeCode: this.detailBudgetList[index].feeBudgetCode }).then((rel) => {
      // request
      //   .post('/mdm/mdmCustomerMsgExtController/findCustomerInfoByOrgCode', {
      //     orgCode: this.detailBudgetList[index].orgCode,
      //     enableStatus: '009',
      //     pageSize: 500,
      //     customerName,
      //   })
      //   .then((rel) => {
      //     if (rel.success) {
      //       console.log(rel);
      //       let resData = rel.result.data;
      //       resData = resData.map((v) => {
      //         const obj = v;
      //         obj.businessObjectCode = obj.customerCode;
      //         obj.businessObjectName = obj.customerName;
      //         return obj;
      //       });
      //       this.$set(
      //         this.detailBudgetList[index],
      //         'custOptions',
      //         resData || [],
      //       );
      //     } else {
      //       this.$set(this.detailBudgetList[index], 'custOptions', []);
      //     }
      //   })
      //   .catch((err) => {
      //     console.log('err', err);
      //   });
    },
    // 选择经销商
    changCust(row, index) {
      this.$set(this.detailBudgetList[index], 'businessObjectCode', row);
      const res = this.detailBudgetList[index].custOptions.find(
        (item) => item.businessObjectCode === row,
      );
      this.$set(
        this.detailBudgetList[index],
        'businessObjectName',
        res.businessObjectName,
      );
      this.$emit('input', {
        detailBudgetList: this.detailBudgetList,
        feeBudgetList: this.feeBudgetList,
      });
      this.$emit('change', {
        detailBudgetList: this.detailBudgetList,
        feeBudgetList: this.feeBudgetList,
      });
    },
    // 选择公司主体
    companyChange(row, index) {
      this.$set(this.detailBudgetList[index], 'companyCode', row);
      const res = this.companyList.find((item) => item.companyCode === row);
      this.$set(this.detailBudgetList[index], 'companyName', res.companyName);
      this.$emit('input', {
        detailBudgetList: this.detailBudgetList,
        feeBudgetList: this.feeBudgetList,
      });
      this.$emit('change', {
        detailBudgetList: this.detailBudgetList,
        feeBudgetList: this.feeBudgetList,
      });
    },
    // 选择红包发放主体
    redPacketCompanyChange(row, index) {
      this.$set(this.detailBudgetList[index], 'companyCode', row);
      const res = this.WJBT_transfer_red_pack_ZT.find(
        (item) => item.dictCode === row,
      );
      this.$set(this.detailBudgetList[index], 'companyName', res.dictValue);
      this.$emit('input', {
        detailBudgetList: this.detailBudgetList,
        feeBudgetList: this.feeBudgetList,
      });
      this.$emit('change', {
        detailBudgetList: this.detailBudgetList,
        feeBudgetList: this.feeBudgetList,
      });
    },
    // 发放组织
    orgChange(row, index) {
      this.$set(this.detailBudgetList[index], 'orgCode', row);
      const res = this.WJBT_transfer_red_pack_ZZ.find(
        (item) => item.dictCode === row,
      );
      this.$set(this.detailBudgetList[index], 'orgName', res.dictValue);
      this.$emit('input', {
        detailBudgetList: this.detailBudgetList,
        feeBudgetList: this.feeBudgetList,
      });
      this.$emit('change', {
        detailBudgetList: this.detailBudgetList,
        feeBudgetList: this.feeBudgetList,
      });
    },
    getCompanyList() {
      request
        .post('/mdm/companyInfo/companyPageList', {
          flagBan: '1',
          pageNum: 1,
          pageSize: 1000,
        })
        .then((res) => {
          console.log(res);
          if (res.success) {
            this.companyList = res.result.data || [];
          }
        });
    },
    // 数据字典
    getDictory() {
      request
        .post('/mdm/mdmdictdata/batchDictSelect', [
          'WJBT_transfer_red_pack_ZT',
          'WJBT_transfer_red_pack_ZZ',
          'fee_budget_type',
        ])
        .then((res) => {
          console.log(res);
          if (res.success) {
            this.WJBT_transfer_red_pack_ZT = res.result.WJBT_transfer_red_pack_ZT || [];
            this.WJBT_transfer_red_pack_ZZ = res.result.WJBT_transfer_red_pack_ZZ || [];
            this.feeBudgetType = res.result.fee_budget_type || [];
          }
        });
    },
    getProList(index) {
      if (this.disabled) {
        return;
      }
      if (!this.detailBudgetList[index].feeBudgetCode) {
        this.$message({
          type: 'warning',
          message: '请选择预算',
        });
        return;
      }
      if (!this.detailBudgetList[index].companyCode) {
        this.$message({
          type: 'warning',
          message: '请选择公司主体',
        });
        return;
      }
      this.chooseIndex = index;
      this.openModal('product');
      // request
      //   .post('/mdm/mdmMaterialExtController/pageList', {
      //     pageNum: 1,
      //     pageSize: 1000,
      //     code: selectedItem.productLevelCode,
      //   })
      //   .then((rel) => {
      //     if (rel.success) {
      //       console.log(rel);
      //       this.$set(
      //         this.detailBudgetList[index],
      //         'proOptions',
      //         rel.result.data || [],
      //       );
      //     } else {
      //       this.$set(this.detailBudgetList[index], 'proOptions', []);
      //     }
      //   })
      //   .catch((err) => {
      //     console.log('err', err);
      //   });
    },
    // 选择产品
    choosePro(row, index) {
      this.$set(this.detailBudgetList[index], 'productCode', row);
      const res = this.detailBudgetList[index].proOptions.find(
        (item) => item.materialCode === row,
      );
      console.log(this.detailBudgetList);
      this.$set(this.detailBudgetList[index], 'productName', res.materialName);
      this.$emit('input', {
        detailBudgetList: this.detailBudgetList,
        feeBudgetList: this.feeBudgetList,
      });
      this.$emit('change', {
        detailBudgetList: this.detailBudgetList,
        feeBudgetList: this.feeBudgetList,
      });
    },
    // 选择回调
    onGetSelect(val) {
      console.log(val);
      if (this.openType === 'one') {
        // 过滤掉已经存在的feeBudgetCode
        const newVals = val.filter(
          (newItem) => !this.feeBudgetList.some(
            (existingItem) => existingItem.feeBudgetCode === newItem.feeBudgetCode,
          ),
        );
        newVals.forEach((it) => {
          const itt = it;
          this.ysOptions.push({
            label: itt.feeBudgetCode,
            value: itt.feeBudgetCode,
            budgetYear: itt.budgetYear,
            productLevelCode: itt.productLevelCode,
            productLevelName: itt.productLevelName,
            orgCode: itt.orgCode,
            orgName: itt.orgName,
          });
          const feeBudgetTypeObj = this.feeBudgetType.find(
            (item) => item.dictCode === itt.feeBudgetType,
          );
          itt.feeBudgetTypeName = feeBudgetTypeObj?.dictValue || itt.feeBudgetType;
        });
        this.feeBudgetList = [...this.feeBudgetList, ...newVals];
      } else if (this.openType === 'two') {
        this.$set(
          this.detailBudgetList[this.chooseIndex],
          'businessObjectName',
          val[0].terminalName,
        );
        this.$set(
          this.detailBudgetList[this.chooseIndex],
          'businessObjectCode',
          val[0].terminalCode,
        );
      } else if (this.openType === 'customer') {
        this.$set(
          this.detailBudgetList[this.chooseIndex],
          'businessObjectName',
          val[0].customerName,
        );
        this.$set(
          this.detailBudgetList[this.chooseIndex],
          'businessObjectCode',
          val[0].customerCode,
        );
      } else if (this.openType === 'product') {
        this.$set(
          this.detailBudgetList[this.chooseIndex],
          'productName',
          val[0].materialName,
        );
        this.$set(
          this.detailBudgetList[this.chooseIndex],
          'productCode',
          val[0].materialCode,
        );
      }

      //   this.detailBudgetList = val;

      this.$emit('input', {
        detailBudgetList: this.detailBudgetList,
        feeBudgetList: this.feeBudgetList,
      });
      this.$emit('change', {
        detailBudgetList: this.detailBudgetList,
        feeBudgetList: this.feeBudgetList,
      });
    },
    // 清除选择
    clearFn() {
      this.detailBudgetList = [];
      this.feeBudgetList = [];
      this.$emit('input', {
        detailBudgetList: this.detailBudgetList,
        feeBudgetList: this.feeBudgetList,
      });
      this.$emit('change', {
        detailBudgetList: this.detailBudgetList,
        feeBudgetList: this.feeBudgetList,
      });
    },
    deletRow(row, index) {
      console.log(row, index);
      const feeCode = row.feeBudgetCode;

      // 删除feeBudgetList中的当前行
      this.feeBudgetList.splice(index, 1);

      // 删除detailBudgetList中与当前行feeBudgetCode相同的行
      this.detailBudgetList = this.detailBudgetList.filter(
        (item) => item.feeBudgetCode !== feeCode,
      );
      console.log(this.detailBudgetList);
      this.detailBudgetList.forEach((item) => {
        item.ysOptions = item.ysOptions.filter(
          (option) => option.value !== feeCode,
        );
      });

      this.$emit('input', {
        detailBudgetList: this.detailBudgetList,
        feeBudgetList: this.feeBudgetList,
      });
      this.$emit('change', {
        detailBudgetList: this.detailBudgetList,
        feeBudgetList: this.feeBudgetList,
      });
    },
    deletRowOne(row, index) {
      console.log(row, index);
      this.detailBudgetList.splice(index, 1);
      this.$emit('input', {
        detailBudgetList: this.detailBudgetList,
        feeBudgetList: this.feeBudgetList,
      });
      this.$emit('change', {
        detailBudgetList: this.detailBudgetList,
        feeBudgetList: this.feeBudgetList,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.title_2 {
  font-size: 16px;
  height: 20px;
  line-height: 20px;
  font-weight: 600;
  margin-top: 30px;
  margin-bottom: 18px;
}
.edit-table {
  margin-left: 0 !important;
}
</style>
